//헤더 컴포넌트
import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../../assets/styles/Palette";
import {
  Body2,
  Sub1,
  Sub2,
  Sub3,
  Caption2,
} from "../../../../assets/styles/Typography";
import images from "../../../../assets/styles/Images";

import { useAtom } from "jotai";
import { PERSONA_STEP, USER_CREDITS, IS_LOGGED_IN } from "../../../AtomStates";
import { useDynamicViewport } from "../../../../assets/DynamicViewport";
import { Button } from "../../../../assets/styles/ButtonStyle";
import PopupWrap from "../../../../assets/styles/Popup";

const MoleculeCreateDisplayHeader = ({
  activeTab,
  setActiveTab,
  completedSteps,
  isLoading,
  isLoadingReport,
  onSave,
  onSubmitConcept, // 1단계: handleSubmitConcept
  onSubmitReport, // 2단계: handleSubmitReport
  onDisplayConversion, // 3단계: handleDisplayConversion
  hasContentDraft,
  onConfirmContent,
  isLoadingTemplate,
  canProceedFromStep1, // 1단계에서 다음 버튼 활성화 조건
  canProceedFromStep2, // 2단계에서 다음 버튼 활성화 조건
  canProceedFromStep3,
  isCreatedMessage,
  setIsCreatedMessage,
  setMessages,
  setInterviewModeType,
  setEditId,
  setEditText,
  messages,
  interviewModeType,
  isMessageLoading,
}) => {
  useDynamicViewport("width=1280"); // 특정페이지에서만 pc화면처럼 보이기
  const navigate = useNavigate();
  const location = useLocation();
  const [showAlert, setShowAlert] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [userCredits, setUserCredits] = useAtom(USER_CREDITS);
  const [isLoggedInState, setIsLoggedInState] = useState(false);
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [alarms, setAlarms] = useState([]);
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [showNewMessagePopup, setShowNewMessagePopup] = useState(false);

  const handlePrevious = () => {
    // 첫 번째 탭에서는 대시보드로 이동 (취소 기능), 다른 탭에서는 이전 탭으로 이동
    if (activeTab === 1) {
      navigate("/EduInfoDashBoard");
    } else if (activeTab > 1) {
      setActiveTab(activeTab - 1);
    }
  };


  const getButtonText = () => {
    switch (activeTab) {
      case 1:
        return "다음";
      // return isSerialEntered ? "다음" : "불러오기";
      case 2:
        return "다음";
      case 3:
        return hasContentDraft ? "다음" : "다음";
      default:
        return "다음";
    }
  };

  const handleActionClick = () => {
    switch (activeTab) {
      case 1:
        onSubmitConcept && onSubmitConcept();

        break;
      case 2:
        if (messages?.length > 0 || interviewModeType === "explanation") {
          onDisplayConversion && onDisplayConversion();
        } else {
          onSubmitReport && onSubmitReport();
        }
        break;
      case 3:
        onConfirmContent && onConfirmContent();
        break;
      case 4:
        navigate("/ApiDashBoard");
        break;
      default:
        onSave && onSave();
    }
  };

  const handleNewMessage = () => {
    setMessages([]);
    setIsCreatedMessage(false);
    setInterviewModeType("explanation");
    setEditId(null);
    setEditText("");
    setShowNewMessagePopup(false);
  };

  const handleExitCancel = () => {
    setShowExitPopup(false);
  };

  const handleExitConfirm = () => {
    setShowExitPopup(false);
    navigate("/InfoDashBoard");
  };

  return (
    <>
      <HeaderWrap>
        {/* 왼쪽: 취소하기 */}
        <LeftSection>
          <LogoContainer onClick={() => setShowExitPopup(true)}>
            <Sub1 color="gray800" style={{ fontWeight: "600" }}>
              Autodisplay
            </Sub1>
          </LogoContainer>
        </LeftSection>

        {/* 중앙: 탭 버튼들 */}
        <CenterSection>
          <TabContainer>
            <TabButton
              isActive={activeTab >= 1}
              onClick={() => setActiveTab(1)}
              disabled={isLoading || isLoadingReport || isLoadingTemplate}
            >
              <TabNumber isActive={activeTab >= 1}>1</TabNumber>
              <TabText isActive={activeTab >= 1}>정보 입력</TabText>
            </TabButton>

            <TabDivider />

            <TabButton
              isActive={activeTab >= 2}
              onClick={() => completedSteps.includes(1) && setActiveTab(2)}
              disabled={
                !completedSteps.includes(1) ||
                isLoading ||
                isLoadingReport ||
                isLoadingTemplate
              }
            >
              <TabNumber isActive={activeTab >= 2}>2</TabNumber>
              <TabText isActive={activeTab >= 2}>메시지 작성</TabText>
            </TabButton>

            <TabDivider />

            <TabButton
              isActive={activeTab >= 3}
              onClick={() => completedSteps.includes(2) && setActiveTab(3)}
              disabled={
                !completedSteps.includes(2) ||
                isLoading ||
                isLoadingReport ||
                isLoadingTemplate
              }
            >
              <TabNumber isActive={activeTab >= 3}>3</TabNumber>
              <TabText isActive={activeTab >= 3}>모드 선택</TabText>
            </TabButton>

            <TabDivider />

            <TabButton
              isActive={activeTab >= 4}
              onClick={() =>
                (completedSteps.includes(3) || completedSteps.includes(4)) &&
                setActiveTab(4)
              }
              disabled={
                !(completedSteps.includes(3) || completedSteps.includes(4)) ||
                isLoading ||
                isLoadingReport ||
                isLoadingTemplate
              }
            >
              <TabNumber isActive={activeTab >= 4}>4</TabNumber>
              <TabText isActive={activeTab >= 4}>콘텐츠 완료</TabText>
            </TabButton>
          </TabContainer>
        </CenterSection>
      </HeaderWrap>

      {/* 하단 버튼 영역 - activeTab이 4가 아닐 때만 표시 */}
      {activeTab !== 4 && (
        <BottomButtonContainer>
          <BottomButtonWrapper>
            <BackButton
              onClick={handlePrevious}
              disabled={isLoading || isLoadingReport || isLoadingTemplate}
            >
              <span>뒤로</span>
            </BackButton>
            {/* {isCreatedMessage && (
              <Button
                style={{
                  background: '#226FFF',
                  color: '#fff',
                  borderRadius: '20px',
                  fontWeight: 600,
                  minWidth: 140,
                  padding: '10px 16px',
                }}
                // onClick={handleNewMessage}
                onClick={() => { setShowNewMessagePopup(true) }}
              >
                새 메시지 작성하기
              </Button>
            )} */}
            <NextButton
              onClick={handleActionClick}
              disabled={
                isLoading ||
                isLoadingReport ||
                isLoadingTemplate ||
                isMessageLoading ||
                (activeTab === 1 && !canProceedFromStep1) ||
                (activeTab === 2 && !canProceedFromStep2) ||
                (activeTab === 3 && !canProceedFromStep3)
              }
            >
              <span>{getButtonText()}</span>
            </NextButton>
          </BottomButtonWrapper>
        </BottomButtonContainer>
      )}

      {showExitPopup && (
        <PopupWrap
          Warning={true}
          title="정말 종료하시겠습니까?"
          message="지금 종료하면 진행 중인 내용이 모두 삭제됩니다. "
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={handleExitCancel}
          onConfirm={handleExitConfirm}
        />
      )}

      {showNewMessagePopup && (
        <PopupWrap
          Warning={true}
          title="정말 종료하시겠습니까?"
          message="새 메시지를 작성하시면 기존 메시지는 삭제됩니다. "
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={() => setShowNewMessagePopup(false)}
          onConfirm={handleNewMessage}
        />
      )}
    </>
  );
};

export default MoleculeCreateDisplayHeader;

const HeaderWrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 53.75px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 28px;
  border-bottom: 1px solid ${palette.lineGray};
  background: ${palette.white};
  z-index: 99;
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
`;

const CancelButton = styled.div`
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`;

const CenterSection = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0px;
`;

const TabDivider = styled.div`
  width: 20px;
  height: 1px;
  background: ${palette.gray300};
  margin: 0 8px;
`;

const TabButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border-radius: 20px;
  border: none;
  background: transparent;
  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  transition: all 0.2s ease;

  ${(props) =>
    props.isActive
      ? css`
          // background: ${palette.gray800};
        `
      : css`
          background: transparent;
          // border: 1px solid ${palette.gray300};
        `}

  &:hover {
    opacity: ${(props) => (props.disabled ? 0.5 : 0.8)};
  }
`;

const TabNumber = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 20%;
  font-family: Poppins;
  font-size: 12px;
  font-weight: 600;
  transition: all 0.2s ease;

  ${(props) =>
    props.isActive
      ? css`
          background: ${palette.gray800};
          color: ${palette.white};
        `
      : css`
          // background: ${palette.gray400};
          color: ${palette.gray800};
          border: 1px solid ${palette.gray300};
        `}
`;

const TabText = styled.div`
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s ease;
  font-family: Pretendard;

  ${(props) =>
    props.isActive
      ? css`
          color: ${palette.gray800};
          font-weight: 600;
        `
      : css`
          color: ${palette.gray500};
          font-weight: 600;
        `}
`;

const BottomButtonContainer = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  padding: 0px;
  margin-bottom: 0px;
  z-index: 100;
`;

const BottomButtonWrapper = styled.div`
  max-width: 820px;
  margin: 0 auto;
  padding: 0 0px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 1px solid #e0e4eb;
  padding-top: 16px;
  margin-bottom: 16px;
`;

const BackButton = styled.button`
  height: 40px;
  min-width: 98px;
  padding: 0 0px;
  background: transparent;
  border: 1px solid #b3b7ba;
  border-radius: 8px;
  cursor: pointer;

  span {
    color: #464c53;
    font-size: 16px;
    font-family: Pretendard;
    font-weight: 700;
    line-height: 28.5px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &:hover:not(:disabled) {
    background: rgba(179, 183, 186, 0.1);
  }
`;

const NextButton = styled.button`
  height: 40px;
  min-width: 98px;
  padding: 0 24px;
  background: #256ef4;
  border: none;
  border-radius: 8px;
  cursor: pointer;

  span {
    color: white;
    font-size: 16px;
    font-family: Pretendard;
    font-weight: 700;
    line-height: 28.5px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background: #b3b7ba;
  }

  &:hover:not(:disabled) {
    background: #0b45b1;
  }
`;
const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  height: 53.75px;
  cursor: pointer; // 클릭 가능하다는 표시
`;
